import * as Bixby from '$/core';

export abstract class HelpCenterService {
  private static baseUrl = Bixby.Constants.API_HELPCENTERCONTROLLER;

  public static async getAll(): Promise<Bixby.Models.HelpCenterItem[]> {
    const route = Bixby.API.ServerRoute.forAction(HelpCenterService.baseUrl);
    const results: Bixby.Models.HelpCenterItem[] = await Bixby.API.get(route);
    return results;
  }

  public static async getByType(type: Bixby.Enums.HelpCenterItemType): Promise<Bixby.Models.HelpCenterItem[]> {
    const url = `${HelpCenterService.baseUrl}/${type}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    const results: Bixby.Models.HelpCenterItem[] = await Bixby.API.get(route);
    return results;
  }

  public static async download(id: string): Promise<Bixby.Models.FileResultMetadata> {
    const url = `${HelpCenterService.baseUrl}/${Bixby.Constants.API_ACTION_DOWNLOAD}/${id}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    const result = await Bixby.API.getFileWithMetadata(route);
    // filenames could have storage container paths, so replace that here
    if (result.filename) {
      const match = result.filename.match(/[^/]*$/);
      if (match && match.length > 0) {
        result.filename = match[0].replace(/"/g, '');
      }
    }
    return result;
  }
}
